// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg viewBox=%270 0 16 16%27 fill=%27white%27 xmlns=%27http://www.w3.org/2000/svg%27%3e%3cpath d=%27M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@100..900&display=swap);"]);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --app-scrollbar-size: 8px;
  --app-scrollbar-radius: 20px;
  --app-scrollbar-inset: 0px;
  --app-scrollbar-track: transparent;
  --app-scrollbar-track-hover: transparent;
  --app-scrollbar-thumb: linear-gradient(#b9c2e0, #b9c2e0);
  --app-scrollbar-thumb-hover: linear-gradient(#a3add2, #a3add2);
  --app-scrollbar-thumb-active: linear-gradient(#a3add2, #a3add2);
  --app-scrollbar-thumb-shadow: none;
  --app-scrollbar-glow-hover: none;
  --app-scrollbar-glow-active: none;
  --app-scrollbar-border-content: transparent;
  --app-scrollbar-border-sidebar: transparent;
  --app-scrollbar-border-modal: transparent;
  --app-scrollbar-color-firefox: #b9c2e0 transparent;
  --app-scrollbar-color-firefox-hover: #b9c2e0 transparent;
}

.container{
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  grid-template-rows: repeat(4, 1fr);
  gap: 20px;
  margin: 10px;
}
.container .card{
  position: relative;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  transition: .5s ease;
  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;
  border-radius: 10px;
}
.container .card h2{
  cursor: pointer;
}
.darken-img {
  filter: brightness(50%);
}
.container .card:nth-child(1){
  background-color: rgb(224, 243, 255);
  padding: 10px;  
}
.container .card:nth-child(2){
  background-color: rgb(250, 205, 236);
  padding: 10px;
}
.container .card:nth-child(3){
  background-color: rgb(219, 250, 195);
  padding: 10px;
}
.container .card:nth-child(4){
  grid-column: 4 / 6;
  grid-row: 1/5;
}
.container .card:nth-child(5){
  grid-column: 6 / 6;
  grid-row: 1/5;
}
.container .card:nth-child(6){
  grid-column:  1/3;
  grid-row: 2/5;
}
.container .card:nth-child(7){
  grid-row: 2/5;
}
.container .card:nth-child(8){
grid-column:  1/3;
}
.container .card:nth-child(9){
  grid-column:  3/6;
  }
/* Responsive */
@media (max-width: 900px){
  .container{
      grid-template-columns: repeat(1, 1fr);
      grid-template-rows: 0.1fr 0.2fr 0.2fr 0.2fr 0.3fr 0.3fr 0.5fr 0.3fr 0.4fr 0.3fr 0.3fr 0.4fr 0.3fr 0.3fr;
  }
  .container .card{
      grid-row: unset !important;
      grid-column: unset !important;
  }
}
.dark-mode {
  background-color: #000;
  color: #e4d6d6;
}
.light-mode {
  color: #4b4848;
}
.high-contrast {
  background-color: #F5F5F5;
  color: #1A1A1A;
}
.responsive-input {
  width: 100%;
  padding: 0.5rem;
}
@media only screen and (max-width: 768px) {
  .responsive-input {
    padding: 0.3rem;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .responsive-input {
    padding: 0.4rem;
  }
}
@media only screen and (min-width: 1024px) {
  .responsive-input {
    padding: 0.5rem;
  }
}
.gm-style .gm-style-iw {
  border: none !important; /* Remove border */
  overflow: visible !important; /* Fixes clipping issues */
}
.gm-style-iw-d {
  overflow: hidden !important; /* Ensures no scrollbars appear */
  box-shadow: none !important; /* Remove any shadow if present */
}
.gm-ui-hover-effect {
  background-color: white !important; /* Change background to white */
  color: white !important; /* Change X color to black, if needed */
}
/* Change the SVG color inside the button */
.text-green-500 {
  color: green;
}
.text-blue-500 {
  color: blue;
}
.text-purple-500 {
  color: purple;
}
.text-red-500 {
  color: red;
}
.custom-scrollbar {
  border-radius: 5px;
}


.installment-plan {
  padding: 20px;
}

.installment-plan form {
  display: flex;
  flex-direction: column;
  max-width: 400px;
  margin: auto;
}

.installment-plan form div {
  margin-bottom: 15px;
}

.installment-plan form label {
  display: block;
  margin-bottom: 5px;
}

.installment-plan form input {
  width: 100%;
  padding: 8px;
}

.installment-plan form button {
  padding: 10px 15px;
}

.installment-plan ul {
  list-style-type: none;
  padding: 0;
}

.installment-plan li {
  margin-bottom: 10px;
}
/* Shared container treatment for scrollable areas */
.overflow-y-auto {
  border-radius: 5px;
}
.spinner {
  border: 6px dashed rgba(28, 137, 226, 0.785);
}
/* Scrollbar visuals are centralized in the canonical block later in this file. */
.spinner {
  border: 6px dashed rgba(28, 137, 226, 0.785);
  border-left-color: rgba(28, 137, 226, 0.785);
  border-radius: 50%;
  width: 80px;
  height: 80px;
  animation: spin 5s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}


/* Spinner CSS */
.spinners {
  border: 4px solid rgba(0, 0, 0, 0.1);
  border-left-color: #4f46e5; /* You can change the color */
  border-radius: 50%;
  width: 40px;
  height: 40px;
  animation: spins 5s linear infinite;
}

@keyframes spins {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}


.toogle:checked~.dot {
    transform: translateX(100%);
    /* background-color: #132b50; */
}
.tooltip {
  position: absolute; /* Make sure it�s positioned correctly */
  z-index: 9999; /* Ensures it appears above most elements */
  white-space: nowrap; /* Prevents long text from wrapping */
}

.group-hover:visible {
  display: block; /* In case visibility is an issue */
}


@media (max-width: 640px) {
  .date-filter-container {
    width: 100%;
    padding: 1rem;
  }
}

@media (min-width: 640px) {
  .date-filter-container {
    width: 300px;
  }
}

@media (min-width: 1024px) {
  .date-filter-container {
    width: 400px;
  }
}
.tooltips {
  position: absolute;
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  white-space: nowrap;
  z-index: 50;
}

.mapFilterSelect .mapFilterSelectRelative {
  margin-top: 0 !important;
}

.mapFilterSelect .mapFilterSelectRelative button {
  height: 44px;
  letter-spacing: 0.5px;
  width: 146px;
  /* background-color: #fefefebd; */
}

.mapFilterSelect .mapFilterSelectRelative ul,
.mapFilterSelect .mapFilterSelectRelative span {
  background-color: #fefefebd;
}

.mapFilterSelect .mapFilterSelectRelative button span,
.mapFilterSelect .mapFilterSelectRelative ul li span,
.mapFilterSelect .mapFilterSelectRelative ul li:hover span{
  background-color: transparent;
}

.map-activity .css-1nmdiq5-menu{
  margin-top: 0px;
  border-top-left-radius: 0px;
  border-top-right-radius: 0px;
  border-bottom-left-radius: 8px;
  border-bottom-right-radius: 8px;
  margin-left: 1px;
  width: 217px;
  z-index: 111 !important;
}

.map-activity .css-1nmdiq5-menu .css-qr46ko{
  padding-inline: 7px;
}

.map-activity:has(.css-1nmdiq5-menu) .css-13cymwt-control,
.map-activity:has(.css-1nmdiq5-menu) .css-t3ipsp-control{
  border-bottom: #000000 !important;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}

.map-activity .css-13cymwt-control,
.map-activity .css-t3ipsp-control{
  border-radius: 8px;
}

.map-activity .css-t3ipsp-control:hover{
border-color: unset !important;
}

.map-activity .css-13cymwt-control .css-hlgwow .css-19bb58m input,
.map-activity .css-t3ipsp-control .css-hlgwow .css-1cfo1cf input{
  border:unset !important;
  outline: unset !important;
  outline-offset: unset !important;
}

.map-activity .css-13cymwt-control .css-1wy0on6 .css-1u9des2-indicatorSeparator,
.map-activity .css-t3ipsp-control .css-1wy0on6 .css-1u9des2-indicatorSeparator{
display: none;
}

.css-d7l1ni-option,
.css-10wo9uf-option:hover {
  background-color: #d7d6d666 !important;
}


.react-tel-input .flag-dropdown{
  border:0 !important;
  border-right:1px solid transparent !important;
}

.scrollbar-width-thin {
  scrollbar-width: thin;
}

.app-scrollbar,
.custom-side-scrollbar,
.custom-scrollbar,
.scrollbar-container,
.table-scroll,
.rtl-table-scroll,
.task-list-scrollbar,
.scrollbar-width-thin,
.scrollbar-thin,
.overflow-y-auto,
.overflow-x-auto,
.overflow-auto,
.scrollbar-surface-modal,
.modal-scrollbar,
.select__menu-list,
.multiple-activity-select-scroll .select__value-container,
.react-selector-selected-scroll .select__value-container {
  scrollbar-width: thin;
  scrollbar-color: var(--app-scrollbar-color-firefox);
  scroll-behavior: smooth;
  transition: scrollbar-color 0.2s ease;
  --app-scrollbar-border-current: var(--app-scrollbar-border-content);
}

.custom-side-scrollbar {
  --app-scrollbar-border-current: var(--app-scrollbar-border-sidebar);
}

.scrollbar-surface-modal,
.modal-scrollbar {
  --app-scrollbar-border-current: var(--app-scrollbar-border-modal);
}

.app-scrollbar:hover,
.custom-side-scrollbar:hover,
.custom-scrollbar:hover,
.scrollbar-container:hover,
.table-scroll:hover,
.rtl-table-scroll:hover,
.task-list-scrollbar:hover,
.scrollbar-width-thin:hover,
.scrollbar-thin:hover,
.overflow-y-auto:hover,
.overflow-x-auto:hover,
.overflow-auto:hover,
.scrollbar-surface-modal:hover,
.modal-scrollbar:hover,
.select__menu-list:hover,
.multiple-activity-select-scroll .select__value-container:hover,
.react-selector-selected-scroll .select__value-container:hover,
.app-scrollbar:focus-within,
.custom-side-scrollbar:focus-within,
.custom-scrollbar:focus-within,
.scrollbar-container:focus-within,
.table-scroll:focus-within,
.rtl-table-scroll:focus-within,
.task-list-scrollbar:focus-within,
.scrollbar-width-thin:focus-within,
.scrollbar-thin:focus-within,
.overflow-y-auto:focus-within,
.overflow-x-auto:focus-within,
.overflow-auto:focus-within,
.scrollbar-surface-modal:focus-within,
.modal-scrollbar:focus-within,
.select__menu-list:focus-within,
.multiple-activity-select-scroll .select__value-container:focus-within,
.react-selector-selected-scroll .select__value-container:focus-within {
  scrollbar-color: var(--app-scrollbar-color-firefox-hover);
}

.app-scrollbar::-webkit-scrollbar,
.custom-side-scrollbar::-webkit-scrollbar,
.custom-scrollbar::-webkit-scrollbar,
.scrollbar-container::-webkit-scrollbar,
.table-scroll::-webkit-scrollbar,
.rtl-table-scroll::-webkit-scrollbar,
.task-list-scrollbar::-webkit-scrollbar,
.scrollbar-width-thin::-webkit-scrollbar,
.scrollbar-thin::-webkit-scrollbar,
.overflow-y-auto::-webkit-scrollbar,
.overflow-x-auto::-webkit-scrollbar,
.overflow-auto::-webkit-scrollbar,
.scrollbar-surface-modal::-webkit-scrollbar,
.modal-scrollbar::-webkit-scrollbar,
.select__menu-list::-webkit-scrollbar,
.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar,
.react-selector-selected-scroll .select__value-container::-webkit-scrollbar {
  width: var(--app-scrollbar-size);
  height: var(--app-scrollbar-size);
}

.app-scrollbar::-webkit-scrollbar-track,
.custom-side-scrollbar::-webkit-scrollbar-track,
.custom-scrollbar::-webkit-scrollbar-track,
.scrollbar-container::-webkit-scrollbar-track,
.table-scroll::-webkit-scrollbar-track,
.rtl-table-scroll::-webkit-scrollbar-track,
.task-list-scrollbar::-webkit-scrollbar-track,
.scrollbar-width-thin::-webkit-scrollbar-track,
.scrollbar-thin::-webkit-scrollbar-track,
.overflow-y-auto::-webkit-scrollbar-track,
.overflow-x-auto::-webkit-scrollbar-track,
.overflow-auto::-webkit-scrollbar-track,
.scrollbar-surface-modal::-webkit-scrollbar-track,
.modal-scrollbar::-webkit-scrollbar-track,
.select__menu-list::-webkit-scrollbar-track,
.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-track,
.react-selector-selected-scroll .select__value-container::-webkit-scrollbar-track {
  background: var(--app-scrollbar-track) !important;
  border-radius: var(--app-scrollbar-radius);
}

.app-scrollbar::-webkit-scrollbar-thumb,
.custom-side-scrollbar::-webkit-scrollbar-thumb,
.custom-scrollbar::-webkit-scrollbar-thumb,
.scrollbar-container::-webkit-scrollbar-thumb,
.table-scroll::-webkit-scrollbar-thumb,
.rtl-table-scroll::-webkit-scrollbar-thumb,
.task-list-scrollbar::-webkit-scrollbar-thumb,
.scrollbar-width-thin::-webkit-scrollbar-thumb,
.scrollbar-thin::-webkit-scrollbar-thumb,
.overflow-y-auto::-webkit-scrollbar-thumb,
.overflow-x-auto::-webkit-scrollbar-thumb,
.overflow-auto::-webkit-scrollbar-thumb,
.scrollbar-surface-modal::-webkit-scrollbar-thumb,
.modal-scrollbar::-webkit-scrollbar-thumb,
.select__menu-list::-webkit-scrollbar-thumb,
.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-thumb,
.react-selector-selected-scroll .select__value-container::-webkit-scrollbar-thumb {
  background-image: none;
  background-color: transparent;
  border-radius: var(--app-scrollbar-radius);
  border: none;
  background-clip: padding-box;
  box-shadow: none;
  -webkit-transition: all 0.18s ease;
  transition: all 0.18s ease;
}

.app-scrollbar:hover::-webkit-scrollbar-thumb,
.custom-side-scrollbar:hover::-webkit-scrollbar-thumb,
.custom-scrollbar:hover::-webkit-scrollbar-thumb,
.scrollbar-container:hover::-webkit-scrollbar-thumb,
.table-scroll:hover::-webkit-scrollbar-thumb,
.rtl-table-scroll:hover::-webkit-scrollbar-thumb,
.task-list-scrollbar:hover::-webkit-scrollbar-thumb,
.scrollbar-width-thin:hover::-webkit-scrollbar-thumb,
.scrollbar-thin:hover::-webkit-scrollbar-thumb,
.overflow-y-auto:hover::-webkit-scrollbar-thumb,
.overflow-x-auto:hover::-webkit-scrollbar-thumb,
.overflow-auto:hover::-webkit-scrollbar-thumb,
.scrollbar-surface-modal:hover::-webkit-scrollbar-thumb,
.modal-scrollbar:hover::-webkit-scrollbar-thumb,
.select__menu-list:hover::-webkit-scrollbar-thumb,
.multiple-activity-select-scroll .select__value-container:hover::-webkit-scrollbar-thumb,
.react-selector-selected-scroll .select__value-container:hover::-webkit-scrollbar-thumb,
.app-scrollbar:focus-within::-webkit-scrollbar-thumb,
.custom-side-scrollbar:focus-within::-webkit-scrollbar-thumb,
.custom-scrollbar:focus-within::-webkit-scrollbar-thumb,
.scrollbar-container:focus-within::-webkit-scrollbar-thumb,
.table-scroll:focus-within::-webkit-scrollbar-thumb,
.rtl-table-scroll:focus-within::-webkit-scrollbar-thumb,
.task-list-scrollbar:focus-within::-webkit-scrollbar-thumb,
.scrollbar-width-thin:focus-within::-webkit-scrollbar-thumb,
.scrollbar-thin:focus-within::-webkit-scrollbar-thumb,
.overflow-y-auto:focus-within::-webkit-scrollbar-thumb,
.overflow-x-auto:focus-within::-webkit-scrollbar-thumb,
.overflow-auto:focus-within::-webkit-scrollbar-thumb,
.scrollbar-surface-modal:focus-within::-webkit-scrollbar-thumb,
.modal-scrollbar:focus-within::-webkit-scrollbar-thumb,
.select__menu-list:focus-within::-webkit-scrollbar-thumb,
.multiple-activity-select-scroll .select__value-container:focus-within::-webkit-scrollbar-thumb,
.react-selector-selected-scroll .select__value-container:focus-within::-webkit-scrollbar-thumb {
  background-image: var(--app-scrollbar-thumb);
  border: var(--app-scrollbar-inset) solid var(--app-scrollbar-border-current);
  box-shadow: var(--app-scrollbar-thumb-shadow);
}

.app-scrollbar:hover::-webkit-scrollbar-track,
.custom-side-scrollbar:hover::-webkit-scrollbar-track,
.custom-scrollbar:hover::-webkit-scrollbar-track,
.scrollbar-container:hover::-webkit-scrollbar-track,
.table-scroll:hover::-webkit-scrollbar-track,
.rtl-table-scroll:hover::-webkit-scrollbar-track,
.task-list-scrollbar:hover::-webkit-scrollbar-track,
.scrollbar-width-thin:hover::-webkit-scrollbar-track,
.scrollbar-thin:hover::-webkit-scrollbar-track,
.overflow-y-auto:hover::-webkit-scrollbar-track,
.overflow-x-auto:hover::-webkit-scrollbar-track,
.overflow-auto:hover::-webkit-scrollbar-track,
.scrollbar-surface-modal:hover::-webkit-scrollbar-track,
.modal-scrollbar:hover::-webkit-scrollbar-track,
.select__menu-list:hover::-webkit-scrollbar-track,
.multiple-activity-select-scroll .select__value-container:hover::-webkit-scrollbar-track,
.react-selector-selected-scroll .select__value-container:hover::-webkit-scrollbar-track,
.app-scrollbar:focus-within::-webkit-scrollbar-track,
.custom-side-scrollbar:focus-within::-webkit-scrollbar-track,
.custom-scrollbar:focus-within::-webkit-scrollbar-track,
.scrollbar-container:focus-within::-webkit-scrollbar-track,
.table-scroll:focus-within::-webkit-scrollbar-track,
.rtl-table-scroll:focus-within::-webkit-scrollbar-track,
.task-list-scrollbar:focus-within::-webkit-scrollbar-track,
.scrollbar-width-thin:focus-within::-webkit-scrollbar-track,
.scrollbar-thin:focus-within::-webkit-scrollbar-track,
.overflow-y-auto:focus-within::-webkit-scrollbar-track,
.overflow-x-auto:focus-within::-webkit-scrollbar-track,
.overflow-auto:focus-within::-webkit-scrollbar-track,
.scrollbar-surface-modal:focus-within::-webkit-scrollbar-track,
.modal-scrollbar:focus-within::-webkit-scrollbar-track,
.select__menu-list:focus-within::-webkit-scrollbar-track,
.multiple-activity-select-scroll .select__value-container:focus-within::-webkit-scrollbar-track,
.react-selector-selected-scroll .select__value-container:focus-within::-webkit-scrollbar-track {
  background: var(--app-scrollbar-track-hover) !important;
}

.app-scrollbar::-webkit-scrollbar-thumb:hover,
.custom-side-scrollbar::-webkit-scrollbar-thumb:hover,
.custom-scrollbar::-webkit-scrollbar-thumb:hover,
.scrollbar-container::-webkit-scrollbar-thumb:hover,
.table-scroll::-webkit-scrollbar-thumb:hover,
.rtl-table-scroll::-webkit-scrollbar-thumb:hover,
.task-list-scrollbar::-webkit-scrollbar-thumb:hover,
.scrollbar-width-thin::-webkit-scrollbar-thumb:hover,
.scrollbar-thin::-webkit-scrollbar-thumb:hover,
.overflow-y-auto::-webkit-scrollbar-thumb:hover,
.overflow-x-auto::-webkit-scrollbar-thumb:hover,
.overflow-auto::-webkit-scrollbar-thumb:hover,
.scrollbar-surface-modal::-webkit-scrollbar-thumb:hover,
.modal-scrollbar::-webkit-scrollbar-thumb:hover,
.select__menu-list::-webkit-scrollbar-thumb:hover,
.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-thumb:hover,
.react-selector-selected-scroll .select__value-container::-webkit-scrollbar-thumb:hover {
  background-image: var(--app-scrollbar-thumb-hover) !important;
  box-shadow: var(--app-scrollbar-glow-hover);
}

.app-scrollbar::-webkit-scrollbar-thumb:active,
.custom-side-scrollbar::-webkit-scrollbar-thumb:active,
.custom-scrollbar::-webkit-scrollbar-thumb:active,
.scrollbar-container::-webkit-scrollbar-thumb:active,
.table-scroll::-webkit-scrollbar-thumb:active,
.rtl-table-scroll::-webkit-scrollbar-thumb:active,
.task-list-scrollbar::-webkit-scrollbar-thumb:active,
.scrollbar-width-thin::-webkit-scrollbar-thumb:active,
.scrollbar-thin::-webkit-scrollbar-thumb:active,
.overflow-y-auto::-webkit-scrollbar-thumb:active,
.overflow-x-auto::-webkit-scrollbar-thumb:active,
.overflow-auto::-webkit-scrollbar-thumb:active,
.scrollbar-surface-modal::-webkit-scrollbar-thumb:active,
.modal-scrollbar::-webkit-scrollbar-thumb:active,
.select__menu-list::-webkit-scrollbar-thumb:active,
.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-thumb:active,
.react-selector-selected-scroll .select__value-container::-webkit-scrollbar-thumb:active {
  background-image: var(--app-scrollbar-thumb-active) !important;
  box-shadow: var(--app-scrollbar-glow-active);
}

.hide-scrollbar {
  scrollbar-width: none !important;
}

body.modal-open .custom-side-scrollbar {
  scrollbar-width: none;
}

body.modal-open .custom-side-scrollbar::-webkit-scrollbar {
  width: 0;
  height: 0;
}

.task-list-table {
  height: 100%;
  min-height: 0;
}

@media (max-width: 639px) {
  .task-list-table {
    height: auto;
    min-height: 420px;
  }
}

@media (min-width: 640px) and (max-height: 716px) {
 .task-list-table{
  height: 100%;
  min-height: 0;
 }
}
[type='text']:focus{
  box-shadow: none !important;
} 

  @media (max-width: 1213px) {
  .header {
   position: absolute;
  }
}

.account-history thead tr th, 
.account-history tbody tr td{
  border : 1px solid #e5e7eb;
}

.custom-draw {
  display: flex;
  gap:5px;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border-radius: 1rem;
  /* box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12); */
  overflow: hidden;
  margin-top: 80px;
  padding: 0.25rem;
  border : 1px solid #d7dfea;
}

.custom-draw.custom-draw-flyout {
  flex-direction: row;
  gap: 6px;
  border-radius: 12px;
  margin-top: 8px;
  padding: 6px;
  background: rgba(255, 255, 255, 0.98);
  border: 1px solid #d7dfea;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  backdrop-filter: blur(8px);
}

.custom-draw.custom-draw-flyout .custom-btn {
  border: 0;
  border-radius: 10px;
  background: transparent;
  position: relative;
}

.custom-draw.custom-draw-flyout .custom-btn:not(:first-child)::before {
  content: "";
  position: absolute;
  inset-inline-start: -3px;
  top: 8px;
  bottom: 8px;
  width: 1px;
  background: #e7edf6;
}

.custom-zoom {
  display: flex;
  gap:5px;
  flex-direction: column;
  align-items: center;
  background: #ffffff;
  border-radius: 14px;
  /* box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12); */
  overflow: hidden;
  margin-top: 80px;
  margin-left: 12px;
  padding: 8px;
  border : 1px solid #d7dfea;
  width: 56px;
}

.map-type-zoom-control {
  gap: 0;
}

.map-type-zoom-control .map-control-group {
  display: flex;
  flex-direction: column;
  gap: 5px;
  align-items: center;
}

.map-type-zoom-control .map-control-divider {
  width: calc(100% - 8px);
  height: 1px;
  margin: 8px 4px;
  background: #e7edf6;
}

/* Right-side map controls (zoom, map type, draw) - below list/map view buttons.
   Note: on desktop, MapTypeControl overrides .custom-zoom's margin-top inline
   at runtime (measured from the Tracking button), which takes precedence over
   the margin-top set here - this value only governs mobile and the brief
   moment before that measurement runs. */
.leaflet-top.leaflet-right .custom-zoom,
.leaflet-top.leaflet-right .custom-draw {
  margin-top: 8px;
  margin-left: 0;
  margin-right: 0;
}

.leaflet-top.leaflet-left .custom-zoom,
.leaflet-top.leaflet-left .custom-draw {
  margin-top: 8px;
  margin-left: 0;
  margin-right: 0;
}

.custom-btn {
  width: 40px;
  height: 40px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  font-size: 22px;
  color:#0f1729;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
}

.custom-btn:hover,
.custom-btn.active {
  background: #f0f6fe;
  border-color: #5286f7;
  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);
}

.custom-btn.active {
  color: #236DB4;
}

#map .map-right-rail-container {
  width: 56px;
  border-radius: 14px;
  border: 1px solid #d7dfea;
  background: #ffffff;
  padding: 8px;
  box-shadow: 0 6px 18px rgba(15, 23, 41, 0.1);
  backdrop-filter: blur(2px);
}

#map .map-right-rail-btn {
  border-radius: 10px;
  border-color: transparent;
  background: transparent;
  color: #0f1729;
}

#map .map-right-rail-btn:hover {
  background: #f0f6fe;
  border-color: transparent;
  color: #0f1729;
}

#map .map-right-rail-btn.map-right-rail-btn-active {
  background: #f0f6fe;
  border-color: #5286f7;
  color: #236DB4;
  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);
}

.custom-zoom-level {
  font-size: 12px;
  font-weight: 600;
  color: #65708b;
  padding: 0.25rem 0;
  -webkit-user-select: none;
          user-select: none;
}

.custom-btn[data-tooltip] {
  position: relative;
  cursor: pointer;
}

.custom-btn[data-tooltip]::after {
  content: attr(data-tooltip);
  position: absolute;
  top: -32px;
  left: 50%;
  transform: translateX(-50%);
  background: #FFF;
  color: #222;
  border: 1px solid #d7dfea;
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.2s;
  z-index: 1000;
}

.custom-btn[data-tooltip]:hover::after {
  opacity: 1;
}

/* Small field info tooltip icon */
.field-info-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border: 1px solid #d1d5db;
  border-radius: 9999px;
  color: #6b7280;
  background: #ffffff;
  cursor: help;
  flex: 0 0 auto;
  position: relative;
}

.field-info-icon[data-tooltip]::after {
  content: attr(data-tooltip);
  position: absolute;
  left: 50%;
  bottom: calc(100% + 8px);
  transform: translateX(-50%);
  background: #111827;
  color: #ffffff;
  border-radius: 6px;
  padding: 6px 8px;
  font-size: 12px;
  line-height: 1.2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.15s ease-in-out;
  z-index: 10000;
}

.field-info-icon[data-tooltip]:hover::after,
.field-info-icon[data-tooltip]:focus::after {
  opacity: 1;
}

.field-info-icon:focus {
  outline: 2px solid rgba(35, 109, 180, 0.4);
  outline-offset: 2px;
}

.dark-mode .field-info-icon {
  background: #0e0e0f;
  color: #e5e7eb;
  border-color: #374151;
}

.dark-mode .field-info-icon[data-tooltip]::after {
  background: #f9fafb;
  color: #111827;
}

.high-contrast .field-info-icon[data-tooltip]::after {
  background: #000000;
  color: #ffffff;
}

.field-info-icon--wrap[data-tooltip]::after {
  white-space: normal;
  width: 220px;
  max-width: 70vw;
  text-align: center;
  line-height: 1.35;
}

/* Drop the bubble below the icon instead of above it. Use on icons near the
   top of the page, where an upward tooltip gets clipped by the viewport. */
.field-info-icon--bottom[data-tooltip]::after {
  bottom: auto;
  top: calc(100% + 8px);
}

/* Keep the bubble inside the viewport for icons sitting near the right edge. */
.field-info-icon--align-right[data-tooltip]::after {
  left: auto;
  right: 0;
  transform: none;
}

/* Circular checkboxes in data tables (Security, Stock, PDF Generator, etc.) */
input[type="checkbox"].table-checkbox {
  appearance: none;
  -webkit-appearance: none;
  border-radius: 9999px;
  background-color: #ffffff;
  border: 1px solid #d1d5db;
  display: inline-grid;
  place-content: center;
  vertical-align: middle;
}

input[type="checkbox"].table-checkbox:checked {
  background-color: #2563eb;
  border-color: #2563eb;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
}

input[type="checkbox"].table-checkbox:focus {
  outline: none;
  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #3b82f6;
}

.dark-mode input[type="checkbox"].table-checkbox {
  background-color: #374151;
  border-color: #4b5563;
}

.dark-mode input[type="checkbox"].table-checkbox:checked {
  background-color: #3b82f6;
  border-color: #3b82f6;
}

/* Tracking line start/end point markers on map */
.tracking-point-marker {
  background: transparent !important;
  border: none !important;
}
.tracking-point-marker .tracking-point-label {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  border: 2px solid #fff;
  box-shadow: 0 1px 4px rgba(0,0,0,0.35);
}
.tracking-point-marker.tracking-start .tracking-point-label {
  background: #16a34a;
}
.tracking-point-marker.tracking-end .tracking-point-label {
  background: #dc2626;
}
/* Visible scrollbar for react-select dropdown menu (e.g. Next step success/failure) */
.select__menu-list {
  overflow-y: auto !important;
}

/* Multi-select chips area: flex min-height + visible scrollbar (MultipleActivitySelect) */
.multiple-activity-select-scroll .select__value-container {
  overflow-y: auto !important;
}

.react-selector-selected-scroll .select__value-container {
  overflow-y: auto !important;
}

.bottom-toolbar-container {
  display: flex;
  gap: 8px;
  padding: 8px;
  border-radius: 14px;
}

.bottom-toolbar-btn {
  width: 38px;
  height: 38px;
  border-radius: 10px;
  border: 1px solid #d7dfea;
  background: #e1e7ef;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}
.bottom-toolbar-btn:hover{
  border-color: #5286f7;
  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);
}
.bottom-toolbar-btn:hover .active {
 color: #5286f7;
  border-color: #5286f7;
  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);
}

.bottom-toolbar-btn svg {
  font-size: 18px;
  color: #374151;
}

/* Shared list/search contract (PR-1) */
.search-shell {
  display: flex;
  width: 100%;
  height: 42px;
  align-items: stretch;
}

.search-input {
  width: 100%;
  height: 42px;
  border: 1px solid #d1d5db;
  border-radius: 0;
  padding: 0 12px;
  font-size: 14px;
  line-height: 1.2;
  color: #111827;
  background: #ffffff;
}

.search-input:focus {
  outline: none;
  border-color: #60a5fa;
  box-shadow: 0 0 0 1px #60a5fa;
}

.search-input-ltr {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
  border-right: 0;
  text-align: left;
}

.search-input-rtl {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
  border-left: 0;
  text-align: right;
}

.search-btn {
  width: 48px;
  height: 42px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #236db4;
  color: #ffffff;
  transition: background-color 0.2s ease;
}

.search-btn:hover {
  background: #1d5d9e;
}

.search-btn-ltr {
  border-top-right-radius: 10px;
  border-bottom-right-radius: 10px;
}

.search-btn-rtl {
  border-top-left-radius: 10px;
  border-bottom-left-radius: 10px;
}

.list-meta-row {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
}

.list-meta-left {
  display: flex;
  align-items: center;
  gap: 10px;
  color: #9ca3af;
  font-size: 14px;
}

.list-meta-range {
  white-space: nowrap;
}

.list-meta-right {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #9ca3af;
  font-size: 14px;
}

.pager-nav {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.pager-icon-btn {
  width: 32px;
  height: 32px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  border: 1px solid transparent;
  color: #94a3b8;
  transition: all 0.2s ease;
}

.pager-icon-btn:hover:not(:disabled) {
  color: #236db4;
  background: #eff6ff;
  border-color: #dbeafe;
}

.pager-icon-btn:disabled {
  opacity: 0.45;
  cursor: not-allowed;
}

/* Task Management map/list flip-card selector */
.map-list-flip-toggle {
  position: relative;
  z-index: 1;
  width: 112px;
  height: 40px;
  padding: 0;
  border: 0;
  border-radius: 10px;
  background: transparent;
  perspective: 600px;
  cursor: pointer;
  vertical-align: middle;
}

.map-list-flip-toggle:hover,
.map-list-flip-toggle:focus-visible {
  z-index: 10001;
}

.map-list-flip-toggle::after {
  content: attr(data-tooltip);
  position: absolute;
  left: 50%;
  top: calc(100% + 9px);
  z-index: 10002;
  width: 200px;
  max-width: calc(100vw - 24px);
  padding: 8px 12px;
  border: 1px solid #93c5fd;
  border-radius: 7px;
  color: #0369a1;
  background: #eff6ff;
  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.14);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;
  text-align: center;
  white-space: normal;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translate(-50%, 4px);
  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;
}

.map-list-flip-toggle::before {
  content: "";
  position: absolute;
  left: 50%;
  top: calc(100% + 4px);
  z-index: 10003;
  width: 10px;
  height: 10px;
  border-top: 1px solid #93c5fd;
  border-left: 1px solid #93c5fd;
  background: #eff6ff;
  opacity: 0;
  visibility: hidden;
  pointer-events: none;
  transform: translateX(-50%) rotate(45deg);
  transition: opacity 0.18s ease, visibility 0.18s ease;
}

.map-list-flip-toggle:hover::after,
.map-list-flip-toggle:focus-visible::after,
.map-list-flip-toggle:hover::before,
.map-list-flip-toggle:focus-visible::before {
  opacity: 1;
  visibility: visible;
}

.map-list-flip-toggle:hover::after,
.map-list-flip-toggle:focus-visible::after {
  transform: translate(-50%, 0);
}

.map-list-flip-toggle--align-left::after {
  left: 0;
  transform: translate(0, 4px);
}

.map-list-flip-toggle--align-left:hover::after,
.map-list-flip-toggle--align-left:focus-visible::after {
  transform: translate(0, 0);
}

.map-list-flip-toggle--align-left::before {
  left: 28px;
}

.map-list-flip-toggle:focus-visible {
  outline: 3px solid rgba(35, 109, 180, 0.3);
  outline-offset: 3px;
}

.map-list-flip-toggle:disabled {
  cursor: default;
}

.map-list-flip-toggle__inner {
  position: relative;
  display: block;
  width: 100%;
  height: 100%;
  transform-style: preserve-3d;
  transition: transform 0.52s cubic-bezier(0.4, 0, 0.2, 1);
}

.map-list-flip-toggle.is-flipping .map-list-flip-toggle__inner {
  transform: rotateY(180deg);
}

.map-list-flip-toggle__face {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  border: 1px solid #d7dfea;
  border-radius: 10px;
  backface-visibility: hidden;
  -webkit-backface-visibility: hidden;
  font-size: 13px;
  font-weight: 600;
  line-height: 1;
  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.12);
}

.map-list-flip-toggle__front {
  color: #236db4;
  background: #ffffff;
}

.map-list-flip-toggle__back {
  color: #ffffff;
  background: #236db4;
  border-color: #236db4;
  transform: rotateY(180deg);
}

.map-list-flip-toggle:hover .map-list-flip-toggle__front {
  border-color: #93bce1;
  background: #f6faff;
  box-shadow: 0 5px 14px rgba(35, 109, 180, 0.17);
}

body.dark .map-list-flip-toggle__front {
  color: #93c5fd;
  background: #1e293b;
  border-color: #475569;
}

body.dark .map-list-flip-toggle__back {
  background: #1d4ed8;
  border-color: #60a5fa;
}

body.dark .map-list-flip-toggle::after {
  color: #bfdbfe;
  background: #172554;
  border-color: #3b82f6;
}

body.dark .map-list-flip-toggle::before {
  background: #172554;
  border-color: #3b82f6;
}

body.high-contrast .map-list-flip-toggle__front {
  color: #000000;
  background: #ffffff;
  border: 2px solid #000000;
}

body.high-contrast .map-list-flip-toggle__back {
  color: #ffffff;
  background: #000000;
  border: 2px solid #ffffff;
}

@media (max-width: 639px) {
  .map-list-flip-toggle {
    width: 96px;
    height: 36px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .map-list-flip-toggle__inner {
    transition-duration: 0.01ms;
  }
}

/* Custom Marker color picker (react-color-palette) - scoped restyle so it
   sits flush inside our own light popover instead of showing its own dark
   card, and to trim the padding/gap the library ships with by default. */
.custom-marker-color-popover .rcp-root {
  --rcp-background-color: transparent;
  --rcp-field-input-color: #111827;
  --rcp-field-input-border-color: #e5e7eb;
  --rcp-field-label-color: #6b7280;
}

.custom-marker-color-popover .rcp {
  border-radius: 10px;
  overflow: hidden;
}

.custom-marker-color-popover .rcp-body {
  padding: 10px 0 0;
  gap: 10px;
}

.custom-marker-color-popover .rcp-field-input {
  background-color: #f9fafb;
}


`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,0BAA0B;EAC1B,kCAAkC;EAClC,wCAAwC;EACxC,wDAAwD;EACxD,8DAA8D;EAC9D,+DAA+D;EAC/D,kCAAkC;EAClC,gCAAgC;EAChC,iCAAiC;EACjC,2CAA2C;EAC3C,2CAA2C;EAC3C,yCAAyC;EACzC,kDAAkD;EAClD,wDAAwD;AAC1D;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,kCAAkC;EAClC,SAAS;EACT,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,8CAA8C;EAC9C,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,uBAAuB;AACzB;AACA;EACE,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,aAAa;AACf;AACA;EACE,aAAa;AACf;AACA;AACA,iBAAiB;AACjB;AACA;EACE,iBAAiB;EACjB;AACF,eAAe;AACf;EACE;MACI,qCAAqC;MACrC,uGAAuG;EAC3G;EACA;MACI,0BAA0B;MAC1B,6BAA6B;EACjC;AACF;AACA;EACE,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EAKE,WAAW;EACX,eAAe;AAHjB;AAKA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF;AACA;EACE,uBAAuB,EAAE,kBAAkB;EAC3C,4BAA4B,EAAE,0BAA0B;AAC1D;AACA;EACE,2BAA2B,EAAE,iCAAiC;EAC9D,2BAA2B,EAAE,iCAAiC;AAChE;AACA;EACE,kCAAkC,EAAE,+BAA+B;EACnE,uBAAuB,EAAE,uCAAuC;AAClE;AACA,2CAA2C;AAC3C;EACE,YAAY;AACd;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;AACf;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;;;AAGA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;AACA,oDAAoD;AACpD;EACE,kBAAkB;AACpB;AACA;EACE,4CAA4C;AAC9C;AACA,iFAAiF;AACjF;EACE,4CAA4C;EAC5C,4CAA4C;EAC5C,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,kCAAkC;AACpC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;;AAGA,gBAAgB;AAChB;EACE,oCAAoC;EACpC,0BAA0B,EAAE,6BAA6B;EACzD,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,mCAAmC;AACrC;;AAEA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,yBAAyB;EAC3B;AACF;;;AAGA;IACI,2BAA2B;IAC3B,+BAA+B;AACnC;AACA;EACE,kBAAkB,EAAE,wCAAwC;EAC5D,aAAa,EAAE,2CAA2C;EAC1D,mBAAmB,EAAE,qCAAqC;AAC5D;;AAEA;EACE,cAAc,EAAE,mCAAmC;AACrD;;;AAGA;EACE;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;AACA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,YAAY;EACZ,iCAAiC;AACnC;;AAEA;;EAEE,2BAA2B;AAC7B;;AAEA;;;EAGE,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,2BAA2B;EAC3B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,iCAAiC;EACjC,8BAA8B;EAC9B,+BAA+B;AACjC;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;AACA,8BAA8B;AAC9B;;AAEA;;EAEE,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;AAEA,aAAa;AACb;;AAEA;;EAEE,sCAAsC;AACxC;;;AAGA;EACE,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA;;;;;;;;;;;;;;;;;EAiBE,qBAAqB;EACrB,mDAAmD;EACnD,uBAAuB;EACvB,qCAAqC;EACrC,mEAAmE;AACrE;;AAEA;EACE,mEAAmE;AACrE;;AAEA;;EAEE,iEAAiE;AACnE;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAkCE,yDAAyD;AAC3D;;AAEA;;;;;;;;;;;;;;;;;EAiBE,gCAAgC;EAChC,iCAAiC;AACnC;;AAEA;;;;;;;;;;;;;;;;;EAiBE,iDAAiD;EACjD,0CAA0C;AAC5C;;AAEA;;;;;;;;;;;;;;;;;EAiBE,sBAAsB;EACtB,6BAA6B;EAC7B,0CAA0C;EAC1C,YAAY;EACZ,4BAA4B;EAC5B,gBAAgB;EAChB,kCAA0B;EAA1B,0BAA0B;AAC5B;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAkCE,4CAA4C;EAC5C,4EAA4E;EAC5E,6CAA6C;AAC/C;;AAEA;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;EAkCE,uDAAuD;AACzD;;AAEA;;;;;;;;;;;;;;;;;EAiBE,6DAA6D;EAC7D,2CAA2C;AAC7C;;AAEA;;;;;;;;;;;;;;;;;EAiBE,8DAA8D;EAC9D,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;EACE;IACE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA;CACC;EACC,YAAY;EACZ,aAAa;CACd;AACD;AACA;EACE,2BAA2B;AAC7B;;EAEE;EACA;GACC,kBAAkB;EACnB;AACF;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gDAAgD;EAChD,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,qCAAqC;EACrC,yBAAyB;EACzB,0CAA0C;EAC1C,0BAA0B;AAC5B;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,wBAAwB;EACxB,QAAQ;EACR,WAAW;EACX,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,OAAO;EACP,sBAAsB;EACtB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,gDAAgD;EAChD,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;EAC1B,WAAW;AACb;;AAEA;EACE,MAAM;AACR;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,mBAAmB;AACrB;;AAEA;;;;yCAIyC;AACzC;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,UAAU;EACV,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;EAChB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,UAAU;EACV,oBAAoB;EACpB,wBAAwB;EACxB,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,wBAAwB;EACxB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,UAAU;EACV,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;AAChB;;AAEA;;EAEE,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;2EAC2E;AAC3E;EACE,YAAY;EACZ,qBAAqB;AACvB;;AAEA,+EAA+E;AAC/E;EACE,UAAU;EACV,QAAQ;EACR,eAAe;AACjB;;AAEA,8EAA8E;AAC9E;EACE,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,yBAAyB;EACzB,yBAAyB;EACzB,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,yDAAsQ;EACtQ,0BAA0B;EAC1B,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,aAAa;EACb,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,iDAAiD;AACjD;EACE,kCAAkC;EAClC,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,sCAAsC;AACxC;AACA;EACE,mBAAmB;AACrB;AACA;EACE,mBAAmB;AACrB;AACA,sFAAsF;AACtF;EACE,2BAA2B;AAC7B;;AAEA,0FAA0F;AAC1F;EACE,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,mDAAmD;AACrD;AACA;CACC,cAAc;EACb,qBAAqB;EACrB,mDAAmD;AACrD;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,uCAAuC;AACvC;EACE,aAAa;EACb,WAAW;EACX,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;EAC/B,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;EAChC,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,sCAAsC;AACxC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,4BAA4B;EAC5B,+BAA+B;AACjC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,6BAA6B;EAC7B,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA,gDAAgD;AAChD;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,6BAA6B;EAC7B,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,6CAA6C;EAC7C,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,+BAA+B;EAC/B,2EAA2E;AAC7E;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,qBAAqB;EACrB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,6BAA6B;EAC7B,8BAA8B;EAC9B,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,oBAAoB;EACpB,yCAAyC;EACzC,qDAAqD;AACvD;;AAEA;;;;EAIE,UAAU;EACV,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,OAAO;EACP,4BAA4B;AAC9B;;AAEA;;EAEE,0BAA0B;AAC5B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,wDAAwD;AAC1D;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,yBAAyB;EACzB,mBAAmB;EACnB,2BAA2B;EAC3B,mCAAmC;EACnC,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF;;AAEA;;yEAEyE;AACzE;EACE,mCAAmC;EACnC,gCAAgC;EAChC,uCAAuC;EACvC,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Arabic:wght@100..900&display=swap');\r\n\r\n:root {\r\n  --app-scrollbar-size: 8px;\r\n  --app-scrollbar-radius: 20px;\r\n  --app-scrollbar-inset: 0px;\r\n  --app-scrollbar-track: transparent;\r\n  --app-scrollbar-track-hover: transparent;\r\n  --app-scrollbar-thumb: linear-gradient(#b9c2e0, #b9c2e0);\r\n  --app-scrollbar-thumb-hover: linear-gradient(#a3add2, #a3add2);\r\n  --app-scrollbar-thumb-active: linear-gradient(#a3add2, #a3add2);\r\n  --app-scrollbar-thumb-shadow: none;\r\n  --app-scrollbar-glow-hover: none;\r\n  --app-scrollbar-glow-active: none;\r\n  --app-scrollbar-border-content: transparent;\r\n  --app-scrollbar-border-sidebar: transparent;\r\n  --app-scrollbar-border-modal: transparent;\r\n  --app-scrollbar-color-firefox: #b9c2e0 transparent;\r\n  --app-scrollbar-color-firefox-hover: #b9c2e0 transparent;\r\n}\r\n\r\n.container{\r\n  display: grid;\r\n  grid-template-columns: repeat(6, 1fr);\r\n  grid-template-rows: repeat(4, 1fr);\r\n  gap: 20px;\r\n  margin: 10px;\r\n}\r\n.container .card{\r\n  position: relative;\r\n  background: #fff;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  color: #fff;\r\n  transition: .5s ease;\r\n  box-shadow: rgba(17, 17, 26, 0.1) 0px 0px 16px;\r\n  border-radius: 10px;\r\n}\r\n.container .card h2{\r\n  cursor: pointer;\r\n}\r\n.darken-img {\r\n  filter: brightness(50%);\r\n}\r\n.container .card:nth-child(1){\r\n  background-color: rgb(224, 243, 255);\r\n  padding: 10px;  \r\n}\r\n.container .card:nth-child(2){\r\n  background-color: rgb(250, 205, 236);\r\n  padding: 10px;\r\n}\r\n.container .card:nth-child(3){\r\n  background-color: rgb(219, 250, 195);\r\n  padding: 10px;\r\n}\r\n.container .card:nth-child(4){\r\n  grid-column: 4 / 6;\r\n  grid-row: 1/5;\r\n}\r\n.container .card:nth-child(5){\r\n  grid-column: 6 / 6;\r\n  grid-row: 1/5;\r\n}\r\n.container .card:nth-child(6){\r\n  grid-column:  1/3;\r\n  grid-row: 2/5;\r\n}\r\n.container .card:nth-child(7){\r\n  grid-row: 2/5;\r\n}\r\n.container .card:nth-child(8){\r\ngrid-column:  1/3;\r\n}\r\n.container .card:nth-child(9){\r\n  grid-column:  3/6;\r\n  }\r\n/* Responsive */\r\n@media (max-width: 900px){\r\n  .container{\r\n      grid-template-columns: repeat(1, 1fr);\r\n      grid-template-rows: 0.1fr 0.2fr 0.2fr 0.2fr 0.3fr 0.3fr 0.5fr 0.3fr 0.4fr 0.3fr 0.3fr 0.4fr 0.3fr 0.3fr;\r\n  }\r\n  .container .card{\r\n      grid-row: unset !important;\r\n      grid-column: unset !important;\r\n  }\r\n}\r\n.dark-mode {\r\n  background-color: #000;\r\n  color: #e4d6d6;\r\n}\r\n.light-mode {\r\n  color: #4b4848;\r\n}\r\n.high-contrast {\r\n  background-color: #F5F5F5;\r\n  color: #1A1A1A;\r\n}\r\n.responsive-input {\r\n  width: 100%;\r\n  padding: 0.5rem;\r\n}\r\n.responsive-input {\r\n  width: 100%;\r\n  padding: 0.5rem; \r\n}\r\n@media only screen and (max-width: 768px) {\r\n  .responsive-input {\r\n    padding: 0.3rem;\r\n  }\r\n}\r\n@media only screen and (min-width: 768px) and (max-width: 1024px) {\r\n  .responsive-input {\r\n    padding: 0.4rem;\r\n  }\r\n}\r\n@media only screen and (min-width: 1024px) {\r\n  .responsive-input {\r\n    padding: 0.5rem;\r\n  }\r\n}\r\n.gm-style .gm-style-iw {\r\n  border: none !important; /* Remove border */\r\n  overflow: visible !important; /* Fixes clipping issues */\r\n}\r\n.gm-style-iw-d {\r\n  overflow: hidden !important; /* Ensures no scrollbars appear */\r\n  box-shadow: none !important; /* Remove any shadow if present */\r\n}\r\n.gm-ui-hover-effect {\r\n  background-color: white !important; /* Change background to white */\r\n  color: white !important; /* Change X color to black, if needed */\r\n}\r\n/* Change the SVG color inside the button */\r\n.text-green-500 {\r\n  color: green;\r\n}\r\n.text-blue-500 {\r\n  color: blue;\r\n}\r\n.text-purple-500 {\r\n  color: purple;\r\n}\r\n.text-red-500 {\r\n  color: red;\r\n}\r\n.custom-scrollbar {\r\n  border-radius: 5px;\r\n}\r\n\r\n\r\n.installment-plan {\r\n  padding: 20px;\r\n}\r\n\r\n.installment-plan form {\r\n  display: flex;\r\n  flex-direction: column;\r\n  max-width: 400px;\r\n  margin: auto;\r\n}\r\n\r\n.installment-plan form div {\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.installment-plan form label {\r\n  display: block;\r\n  margin-bottom: 5px;\r\n}\r\n\r\n.installment-plan form input {\r\n  width: 100%;\r\n  padding: 8px;\r\n}\r\n\r\n.installment-plan form button {\r\n  padding: 10px 15px;\r\n}\r\n\r\n.installment-plan ul {\r\n  list-style-type: none;\r\n  padding: 0;\r\n}\r\n\r\n.installment-plan li {\r\n  margin-bottom: 10px;\r\n}\r\n/* Shared container treatment for scrollable areas */\r\n.overflow-y-auto {\r\n  border-radius: 5px;\r\n}\r\n.spinner {\r\n  border: 6px dashed rgba(28, 137, 226, 0.785);\r\n}\r\n/* Scrollbar visuals are centralized in the canonical block later in this file. */\r\n.spinner {\r\n  border: 6px dashed rgba(28, 137, 226, 0.785);\r\n  border-left-color: rgba(28, 137, 226, 0.785);\r\n  border-radius: 50%;\r\n  width: 80px;\r\n  height: 80px;\r\n  animation: spin 5s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n  to {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n\r\n/* Spinner CSS */\r\n.spinners {\r\n  border: 4px solid rgba(0, 0, 0, 0.1);\r\n  border-left-color: #4f46e5; /* You can change the color */\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  animation: spins 5s linear infinite;\r\n}\r\n\r\n@keyframes spins {\r\n  0% {\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    transform: rotate(360deg);\r\n  }\r\n}\r\n\r\n\r\n.toogle:checked~.dot {\r\n    transform: translateX(100%);\r\n    /* background-color: #132b50; */\r\n}\r\n.tooltip {\r\n  position: absolute; /* Make sure it�s positioned correctly */\r\n  z-index: 9999; /* Ensures it appears above most elements */\r\n  white-space: nowrap; /* Prevents long text from wrapping */\r\n}\r\n\r\n.group-hover:visible {\r\n  display: block; /* In case visibility is an issue */\r\n}\r\n\r\n\r\n@media (max-width: 640px) {\r\n  .date-filter-container {\r\n    width: 100%;\r\n    padding: 1rem;\r\n  }\r\n}\r\n\r\n@media (min-width: 640px) {\r\n  .date-filter-container {\r\n    width: 300px;\r\n  }\r\n}\r\n\r\n@media (min-width: 1024px) {\r\n  .date-filter-container {\r\n    width: 400px;\r\n  }\r\n}\r\n.tooltips {\r\n  position: absolute;\r\n  background: rgba(0, 0, 0, 0.8);\r\n  color: white;\r\n  padding: 0.25rem 0.5rem;\r\n  border-radius: 0.25rem;\r\n  white-space: nowrap;\r\n  z-index: 50;\r\n}\r\n\r\n.mapFilterSelect .mapFilterSelectRelative {\r\n  margin-top: 0 !important;\r\n}\r\n\r\n.mapFilterSelect .mapFilterSelectRelative button {\r\n  height: 44px;\r\n  letter-spacing: 0.5px;\r\n  width: 146px;\r\n  /* background-color: #fefefebd; */\r\n}\r\n\r\n.mapFilterSelect .mapFilterSelectRelative ul,\r\n.mapFilterSelect .mapFilterSelectRelative span {\r\n  background-color: #fefefebd;\r\n}\r\n\r\n.mapFilterSelect .mapFilterSelectRelative button span,\r\n.mapFilterSelect .mapFilterSelectRelative ul li span,\r\n.mapFilterSelect .mapFilterSelectRelative ul li:hover span{\r\n  background-color: transparent;\r\n}\r\n\r\n.map-activity .css-1nmdiq5-menu{\r\n  margin-top: 0px;\r\n  border-top-left-radius: 0px;\r\n  border-top-right-radius: 0px;\r\n  border-bottom-left-radius: 8px;\r\n  border-bottom-right-radius: 8px;\r\n  margin-left: 1px;\r\n  width: 217px;\r\n  z-index: 111 !important;\r\n}\r\n\r\n.map-activity .css-1nmdiq5-menu .css-qr46ko{\r\n  padding-inline: 7px;\r\n}\r\n\r\n.map-activity:has(.css-1nmdiq5-menu) .css-13cymwt-control,\r\n.map-activity:has(.css-1nmdiq5-menu) .css-t3ipsp-control{\r\n  border-bottom: #000000 !important;\r\n  border-bottom-left-radius: 0px;\r\n  border-bottom-right-radius: 0px;\r\n}\r\n\r\n.map-activity .css-13cymwt-control,\r\n.map-activity .css-t3ipsp-control{\r\n  border-radius: 8px;\r\n}\r\n\r\n.map-activity .css-t3ipsp-control:hover{\r\nborder-color: unset !important;\r\n}\r\n\r\n.map-activity .css-13cymwt-control .css-hlgwow .css-19bb58m input,\r\n.map-activity .css-t3ipsp-control .css-hlgwow .css-1cfo1cf input{\r\n  border:unset !important;\r\n  outline: unset !important;\r\n  outline-offset: unset !important;\r\n}\r\n\r\n.map-activity .css-13cymwt-control .css-1wy0on6 .css-1u9des2-indicatorSeparator,\r\n.map-activity .css-t3ipsp-control .css-1wy0on6 .css-1u9des2-indicatorSeparator{\r\ndisplay: none;\r\n}\r\n\r\n.css-d7l1ni-option,\r\n.css-10wo9uf-option:hover {\r\n  background-color: #d7d6d666 !important;\r\n}\r\n\r\n\r\n.react-tel-input .flag-dropdown{\r\n  border:0 !important;\r\n  border-right:1px solid transparent !important;\r\n}\r\n\r\n.scrollbar-width-thin {\r\n  scrollbar-width: thin;\r\n}\r\n\r\n.app-scrollbar,\r\n.custom-side-scrollbar,\r\n.custom-scrollbar,\r\n.scrollbar-container,\r\n.table-scroll,\r\n.rtl-table-scroll,\r\n.task-list-scrollbar,\r\n.scrollbar-width-thin,\r\n.scrollbar-thin,\r\n.overflow-y-auto,\r\n.overflow-x-auto,\r\n.overflow-auto,\r\n.scrollbar-surface-modal,\r\n.modal-scrollbar,\r\n.select__menu-list,\r\n.multiple-activity-select-scroll .select__value-container,\r\n.react-selector-selected-scroll .select__value-container {\r\n  scrollbar-width: thin;\r\n  scrollbar-color: var(--app-scrollbar-color-firefox);\r\n  scroll-behavior: smooth;\r\n  transition: scrollbar-color 0.2s ease;\r\n  --app-scrollbar-border-current: var(--app-scrollbar-border-content);\r\n}\r\n\r\n.custom-side-scrollbar {\r\n  --app-scrollbar-border-current: var(--app-scrollbar-border-sidebar);\r\n}\r\n\r\n.scrollbar-surface-modal,\r\n.modal-scrollbar {\r\n  --app-scrollbar-border-current: var(--app-scrollbar-border-modal);\r\n}\r\n\r\n.app-scrollbar:hover,\r\n.custom-side-scrollbar:hover,\r\n.custom-scrollbar:hover,\r\n.scrollbar-container:hover,\r\n.table-scroll:hover,\r\n.rtl-table-scroll:hover,\r\n.task-list-scrollbar:hover,\r\n.scrollbar-width-thin:hover,\r\n.scrollbar-thin:hover,\r\n.overflow-y-auto:hover,\r\n.overflow-x-auto:hover,\r\n.overflow-auto:hover,\r\n.scrollbar-surface-modal:hover,\r\n.modal-scrollbar:hover,\r\n.select__menu-list:hover,\r\n.multiple-activity-select-scroll .select__value-container:hover,\r\n.react-selector-selected-scroll .select__value-container:hover,\r\n.app-scrollbar:focus-within,\r\n.custom-side-scrollbar:focus-within,\r\n.custom-scrollbar:focus-within,\r\n.scrollbar-container:focus-within,\r\n.table-scroll:focus-within,\r\n.rtl-table-scroll:focus-within,\r\n.task-list-scrollbar:focus-within,\r\n.scrollbar-width-thin:focus-within,\r\n.scrollbar-thin:focus-within,\r\n.overflow-y-auto:focus-within,\r\n.overflow-x-auto:focus-within,\r\n.overflow-auto:focus-within,\r\n.scrollbar-surface-modal:focus-within,\r\n.modal-scrollbar:focus-within,\r\n.select__menu-list:focus-within,\r\n.multiple-activity-select-scroll .select__value-container:focus-within,\r\n.react-selector-selected-scroll .select__value-container:focus-within {\r\n  scrollbar-color: var(--app-scrollbar-color-firefox-hover);\r\n}\r\n\r\n.app-scrollbar::-webkit-scrollbar,\r\n.custom-side-scrollbar::-webkit-scrollbar,\r\n.custom-scrollbar::-webkit-scrollbar,\r\n.scrollbar-container::-webkit-scrollbar,\r\n.table-scroll::-webkit-scrollbar,\r\n.rtl-table-scroll::-webkit-scrollbar,\r\n.task-list-scrollbar::-webkit-scrollbar,\r\n.scrollbar-width-thin::-webkit-scrollbar,\r\n.scrollbar-thin::-webkit-scrollbar,\r\n.overflow-y-auto::-webkit-scrollbar,\r\n.overflow-x-auto::-webkit-scrollbar,\r\n.overflow-auto::-webkit-scrollbar,\r\n.scrollbar-surface-modal::-webkit-scrollbar,\r\n.modal-scrollbar::-webkit-scrollbar,\r\n.select__menu-list::-webkit-scrollbar,\r\n.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar,\r\n.react-selector-selected-scroll .select__value-container::-webkit-scrollbar {\r\n  width: var(--app-scrollbar-size);\r\n  height: var(--app-scrollbar-size);\r\n}\r\n\r\n.app-scrollbar::-webkit-scrollbar-track,\r\n.custom-side-scrollbar::-webkit-scrollbar-track,\r\n.custom-scrollbar::-webkit-scrollbar-track,\r\n.scrollbar-container::-webkit-scrollbar-track,\r\n.table-scroll::-webkit-scrollbar-track,\r\n.rtl-table-scroll::-webkit-scrollbar-track,\r\n.task-list-scrollbar::-webkit-scrollbar-track,\r\n.scrollbar-width-thin::-webkit-scrollbar-track,\r\n.scrollbar-thin::-webkit-scrollbar-track,\r\n.overflow-y-auto::-webkit-scrollbar-track,\r\n.overflow-x-auto::-webkit-scrollbar-track,\r\n.overflow-auto::-webkit-scrollbar-track,\r\n.scrollbar-surface-modal::-webkit-scrollbar-track,\r\n.modal-scrollbar::-webkit-scrollbar-track,\r\n.select__menu-list::-webkit-scrollbar-track,\r\n.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-track,\r\n.react-selector-selected-scroll .select__value-container::-webkit-scrollbar-track {\r\n  background: var(--app-scrollbar-track) !important;\r\n  border-radius: var(--app-scrollbar-radius);\r\n}\r\n\r\n.app-scrollbar::-webkit-scrollbar-thumb,\r\n.custom-side-scrollbar::-webkit-scrollbar-thumb,\r\n.custom-scrollbar::-webkit-scrollbar-thumb,\r\n.scrollbar-container::-webkit-scrollbar-thumb,\r\n.table-scroll::-webkit-scrollbar-thumb,\r\n.rtl-table-scroll::-webkit-scrollbar-thumb,\r\n.task-list-scrollbar::-webkit-scrollbar-thumb,\r\n.scrollbar-width-thin::-webkit-scrollbar-thumb,\r\n.scrollbar-thin::-webkit-scrollbar-thumb,\r\n.overflow-y-auto::-webkit-scrollbar-thumb,\r\n.overflow-x-auto::-webkit-scrollbar-thumb,\r\n.overflow-auto::-webkit-scrollbar-thumb,\r\n.scrollbar-surface-modal::-webkit-scrollbar-thumb,\r\n.modal-scrollbar::-webkit-scrollbar-thumb,\r\n.select__menu-list::-webkit-scrollbar-thumb,\r\n.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-thumb,\r\n.react-selector-selected-scroll .select__value-container::-webkit-scrollbar-thumb {\r\n  background-image: none;\r\n  background-color: transparent;\r\n  border-radius: var(--app-scrollbar-radius);\r\n  border: none;\r\n  background-clip: padding-box;\r\n  box-shadow: none;\r\n  transition: all 0.18s ease;\r\n}\r\n\r\n.app-scrollbar:hover::-webkit-scrollbar-thumb,\r\n.custom-side-scrollbar:hover::-webkit-scrollbar-thumb,\r\n.custom-scrollbar:hover::-webkit-scrollbar-thumb,\r\n.scrollbar-container:hover::-webkit-scrollbar-thumb,\r\n.table-scroll:hover::-webkit-scrollbar-thumb,\r\n.rtl-table-scroll:hover::-webkit-scrollbar-thumb,\r\n.task-list-scrollbar:hover::-webkit-scrollbar-thumb,\r\n.scrollbar-width-thin:hover::-webkit-scrollbar-thumb,\r\n.scrollbar-thin:hover::-webkit-scrollbar-thumb,\r\n.overflow-y-auto:hover::-webkit-scrollbar-thumb,\r\n.overflow-x-auto:hover::-webkit-scrollbar-thumb,\r\n.overflow-auto:hover::-webkit-scrollbar-thumb,\r\n.scrollbar-surface-modal:hover::-webkit-scrollbar-thumb,\r\n.modal-scrollbar:hover::-webkit-scrollbar-thumb,\r\n.select__menu-list:hover::-webkit-scrollbar-thumb,\r\n.multiple-activity-select-scroll .select__value-container:hover::-webkit-scrollbar-thumb,\r\n.react-selector-selected-scroll .select__value-container:hover::-webkit-scrollbar-thumb,\r\n.app-scrollbar:focus-within::-webkit-scrollbar-thumb,\r\n.custom-side-scrollbar:focus-within::-webkit-scrollbar-thumb,\r\n.custom-scrollbar:focus-within::-webkit-scrollbar-thumb,\r\n.scrollbar-container:focus-within::-webkit-scrollbar-thumb,\r\n.table-scroll:focus-within::-webkit-scrollbar-thumb,\r\n.rtl-table-scroll:focus-within::-webkit-scrollbar-thumb,\r\n.task-list-scrollbar:focus-within::-webkit-scrollbar-thumb,\r\n.scrollbar-width-thin:focus-within::-webkit-scrollbar-thumb,\r\n.scrollbar-thin:focus-within::-webkit-scrollbar-thumb,\r\n.overflow-y-auto:focus-within::-webkit-scrollbar-thumb,\r\n.overflow-x-auto:focus-within::-webkit-scrollbar-thumb,\r\n.overflow-auto:focus-within::-webkit-scrollbar-thumb,\r\n.scrollbar-surface-modal:focus-within::-webkit-scrollbar-thumb,\r\n.modal-scrollbar:focus-within::-webkit-scrollbar-thumb,\r\n.select__menu-list:focus-within::-webkit-scrollbar-thumb,\r\n.multiple-activity-select-scroll .select__value-container:focus-within::-webkit-scrollbar-thumb,\r\n.react-selector-selected-scroll .select__value-container:focus-within::-webkit-scrollbar-thumb {\r\n  background-image: var(--app-scrollbar-thumb);\r\n  border: var(--app-scrollbar-inset) solid var(--app-scrollbar-border-current);\r\n  box-shadow: var(--app-scrollbar-thumb-shadow);\r\n}\r\n\r\n.app-scrollbar:hover::-webkit-scrollbar-track,\r\n.custom-side-scrollbar:hover::-webkit-scrollbar-track,\r\n.custom-scrollbar:hover::-webkit-scrollbar-track,\r\n.scrollbar-container:hover::-webkit-scrollbar-track,\r\n.table-scroll:hover::-webkit-scrollbar-track,\r\n.rtl-table-scroll:hover::-webkit-scrollbar-track,\r\n.task-list-scrollbar:hover::-webkit-scrollbar-track,\r\n.scrollbar-width-thin:hover::-webkit-scrollbar-track,\r\n.scrollbar-thin:hover::-webkit-scrollbar-track,\r\n.overflow-y-auto:hover::-webkit-scrollbar-track,\r\n.overflow-x-auto:hover::-webkit-scrollbar-track,\r\n.overflow-auto:hover::-webkit-scrollbar-track,\r\n.scrollbar-surface-modal:hover::-webkit-scrollbar-track,\r\n.modal-scrollbar:hover::-webkit-scrollbar-track,\r\n.select__menu-list:hover::-webkit-scrollbar-track,\r\n.multiple-activity-select-scroll .select__value-container:hover::-webkit-scrollbar-track,\r\n.react-selector-selected-scroll .select__value-container:hover::-webkit-scrollbar-track,\r\n.app-scrollbar:focus-within::-webkit-scrollbar-track,\r\n.custom-side-scrollbar:focus-within::-webkit-scrollbar-track,\r\n.custom-scrollbar:focus-within::-webkit-scrollbar-track,\r\n.scrollbar-container:focus-within::-webkit-scrollbar-track,\r\n.table-scroll:focus-within::-webkit-scrollbar-track,\r\n.rtl-table-scroll:focus-within::-webkit-scrollbar-track,\r\n.task-list-scrollbar:focus-within::-webkit-scrollbar-track,\r\n.scrollbar-width-thin:focus-within::-webkit-scrollbar-track,\r\n.scrollbar-thin:focus-within::-webkit-scrollbar-track,\r\n.overflow-y-auto:focus-within::-webkit-scrollbar-track,\r\n.overflow-x-auto:focus-within::-webkit-scrollbar-track,\r\n.overflow-auto:focus-within::-webkit-scrollbar-track,\r\n.scrollbar-surface-modal:focus-within::-webkit-scrollbar-track,\r\n.modal-scrollbar:focus-within::-webkit-scrollbar-track,\r\n.select__menu-list:focus-within::-webkit-scrollbar-track,\r\n.multiple-activity-select-scroll .select__value-container:focus-within::-webkit-scrollbar-track,\r\n.react-selector-selected-scroll .select__value-container:focus-within::-webkit-scrollbar-track {\r\n  background: var(--app-scrollbar-track-hover) !important;\r\n}\r\n\r\n.app-scrollbar::-webkit-scrollbar-thumb:hover,\r\n.custom-side-scrollbar::-webkit-scrollbar-thumb:hover,\r\n.custom-scrollbar::-webkit-scrollbar-thumb:hover,\r\n.scrollbar-container::-webkit-scrollbar-thumb:hover,\r\n.table-scroll::-webkit-scrollbar-thumb:hover,\r\n.rtl-table-scroll::-webkit-scrollbar-thumb:hover,\r\n.task-list-scrollbar::-webkit-scrollbar-thumb:hover,\r\n.scrollbar-width-thin::-webkit-scrollbar-thumb:hover,\r\n.scrollbar-thin::-webkit-scrollbar-thumb:hover,\r\n.overflow-y-auto::-webkit-scrollbar-thumb:hover,\r\n.overflow-x-auto::-webkit-scrollbar-thumb:hover,\r\n.overflow-auto::-webkit-scrollbar-thumb:hover,\r\n.scrollbar-surface-modal::-webkit-scrollbar-thumb:hover,\r\n.modal-scrollbar::-webkit-scrollbar-thumb:hover,\r\n.select__menu-list::-webkit-scrollbar-thumb:hover,\r\n.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-thumb:hover,\r\n.react-selector-selected-scroll .select__value-container::-webkit-scrollbar-thumb:hover {\r\n  background-image: var(--app-scrollbar-thumb-hover) !important;\r\n  box-shadow: var(--app-scrollbar-glow-hover);\r\n}\r\n\r\n.app-scrollbar::-webkit-scrollbar-thumb:active,\r\n.custom-side-scrollbar::-webkit-scrollbar-thumb:active,\r\n.custom-scrollbar::-webkit-scrollbar-thumb:active,\r\n.scrollbar-container::-webkit-scrollbar-thumb:active,\r\n.table-scroll::-webkit-scrollbar-thumb:active,\r\n.rtl-table-scroll::-webkit-scrollbar-thumb:active,\r\n.task-list-scrollbar::-webkit-scrollbar-thumb:active,\r\n.scrollbar-width-thin::-webkit-scrollbar-thumb:active,\r\n.scrollbar-thin::-webkit-scrollbar-thumb:active,\r\n.overflow-y-auto::-webkit-scrollbar-thumb:active,\r\n.overflow-x-auto::-webkit-scrollbar-thumb:active,\r\n.overflow-auto::-webkit-scrollbar-thumb:active,\r\n.scrollbar-surface-modal::-webkit-scrollbar-thumb:active,\r\n.modal-scrollbar::-webkit-scrollbar-thumb:active,\r\n.select__menu-list::-webkit-scrollbar-thumb:active,\r\n.multiple-activity-select-scroll .select__value-container::-webkit-scrollbar-thumb:active,\r\n.react-selector-selected-scroll .select__value-container::-webkit-scrollbar-thumb:active {\r\n  background-image: var(--app-scrollbar-thumb-active) !important;\r\n  box-shadow: var(--app-scrollbar-glow-active);\r\n}\r\n\r\n.hide-scrollbar {\r\n  scrollbar-width: none !important;\r\n}\r\n\r\nbody.modal-open .custom-side-scrollbar {\r\n  scrollbar-width: none;\r\n}\r\n\r\nbody.modal-open .custom-side-scrollbar::-webkit-scrollbar {\r\n  width: 0;\r\n  height: 0;\r\n}\r\n\r\n.task-list-table {\r\n  height: 100%;\r\n  min-height: 0;\r\n}\r\n\r\n@media (max-width: 639px) {\r\n  .task-list-table {\r\n    height: auto;\r\n    min-height: 420px;\r\n  }\r\n}\r\n\r\n@media (min-width: 640px) and (max-height: 716px) {\r\n .task-list-table{\r\n  height: 100%;\r\n  min-height: 0;\r\n }\r\n}\r\n[type='text']:focus{\r\n  box-shadow: none !important;\r\n} \r\n\r\n  @media (max-width: 1213px) {\r\n  .header {\r\n   position: absolute;\r\n  }\r\n}\r\n\r\n.account-history thead tr th, \r\n.account-history tbody tr td{\r\n  border : 1px solid #e5e7eb;\r\n}\r\n\r\n.custom-draw {\r\n  display: flex;\r\n  gap:5px;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  background: #ffffff;\r\n  border-radius: 1rem;\r\n  /* box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12); */\r\n  overflow: hidden;\r\n  margin-top: 80px;\r\n  padding: 0.25rem;\r\n  border : 1px solid #d7dfea;\r\n}\r\n\r\n.custom-draw.custom-draw-flyout {\r\n  flex-direction: row;\r\n  gap: 6px;\r\n  border-radius: 12px;\r\n  margin-top: 8px;\r\n  padding: 6px;\r\n  background: rgba(255, 255, 255, 0.98);\r\n  border: 1px solid #d7dfea;\r\n  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);\r\n  backdrop-filter: blur(8px);\r\n}\r\n\r\n.custom-draw.custom-draw-flyout .custom-btn {\r\n  border: 0;\r\n  border-radius: 10px;\r\n  background: transparent;\r\n  position: relative;\r\n}\r\n\r\n.custom-draw.custom-draw-flyout .custom-btn:not(:first-child)::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  inset-inline-start: -3px;\r\n  top: 8px;\r\n  bottom: 8px;\r\n  width: 1px;\r\n  background: #e7edf6;\r\n}\r\n\r\n.custom-zoom {\r\n  display: flex;\r\n  gap:5px;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  background: #ffffff;\r\n  border-radius: 14px;\r\n  /* box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12); */\r\n  overflow: hidden;\r\n  margin-top: 80px;\r\n  margin-left: 12px;\r\n  padding: 8px;\r\n  border : 1px solid #d7dfea;\r\n  width: 56px;\r\n}\r\n\r\n.map-type-zoom-control {\r\n  gap: 0;\r\n}\r\n\r\n.map-type-zoom-control .map-control-group {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 5px;\r\n  align-items: center;\r\n}\r\n\r\n.map-type-zoom-control .map-control-divider {\r\n  width: calc(100% - 8px);\r\n  height: 1px;\r\n  margin: 8px 4px;\r\n  background: #e7edf6;\r\n}\r\n\r\n/* Right-side map controls (zoom, map type, draw) - below list/map view buttons.\r\n   Note: on desktop, MapTypeControl overrides .custom-zoom's margin-top inline\r\n   at runtime (measured from the Tracking button), which takes precedence over\r\n   the margin-top set here - this value only governs mobile and the brief\r\n   moment before that measurement runs. */\r\n.leaflet-top.leaflet-right .custom-zoom,\r\n.leaflet-top.leaflet-right .custom-draw {\r\n  margin-top: 8px;\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n}\r\n\r\n.leaflet-top.leaflet-left .custom-zoom,\r\n.leaflet-top.leaflet-left .custom-draw {\r\n  margin-top: 8px;\r\n  margin-left: 0;\r\n  margin-right: 0;\r\n}\r\n\r\n.custom-btn {\r\n  width: 40px;\r\n  height: 40px;\r\n  border: 1px solid transparent;\r\n  border-radius: 10px;\r\n  background: transparent;\r\n  font-size: 22px;\r\n  color:#0f1729;\r\n  cursor: pointer;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.custom-btn:hover,\r\n.custom-btn.active {\r\n  background: #f0f6fe;\r\n  border-color: #5286f7;\r\n  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);\r\n}\r\n\r\n.custom-btn.active {\r\n  color: #236DB4;\r\n}\r\n\r\n#map .map-right-rail-container {\r\n  width: 56px;\r\n  border-radius: 14px;\r\n  border: 1px solid #d7dfea;\r\n  background: #ffffff;\r\n  padding: 8px;\r\n  box-shadow: 0 6px 18px rgba(15, 23, 41, 0.1);\r\n  backdrop-filter: blur(2px);\r\n}\r\n\r\n#map .map-right-rail-btn {\r\n  border-radius: 10px;\r\n  border-color: transparent;\r\n  background: transparent;\r\n  color: #0f1729;\r\n}\r\n\r\n#map .map-right-rail-btn:hover {\r\n  background: #f0f6fe;\r\n  border-color: transparent;\r\n  color: #0f1729;\r\n}\r\n\r\n#map .map-right-rail-btn.map-right-rail-btn-active {\r\n  background: #f0f6fe;\r\n  border-color: #5286f7;\r\n  color: #236DB4;\r\n  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);\r\n}\r\n\r\n.custom-zoom-level {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #65708b;\r\n  padding: 0.25rem 0;\r\n  user-select: none;\r\n}\r\n\r\n.custom-btn[data-tooltip] {\r\n  position: relative;\r\n  cursor: pointer;\r\n}\r\n\r\n.custom-btn[data-tooltip]::after {\r\n  content: attr(data-tooltip);\r\n  position: absolute;\r\n  top: -32px;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  background: #FFF;\r\n  color: #222;\r\n  border: 1px solid #d7dfea;\r\n  padding: 4px 8px;\r\n  border-radius: 4px;\r\n  font-size: 12px;\r\n  white-space: nowrap;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 0.2s;\r\n  z-index: 1000;\r\n}\r\n\r\n.custom-btn[data-tooltip]:hover::after {\r\n  opacity: 1;\r\n}\r\n\r\n/* Small field info tooltip icon */\r\n.field-info-icon {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 18px;\r\n  height: 18px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 9999px;\r\n  color: #6b7280;\r\n  background: #ffffff;\r\n  cursor: help;\r\n  flex: 0 0 auto;\r\n  position: relative;\r\n}\r\n\r\n.field-info-icon[data-tooltip]::after {\r\n  content: attr(data-tooltip);\r\n  position: absolute;\r\n  left: 50%;\r\n  bottom: calc(100% + 8px);\r\n  transform: translateX(-50%);\r\n  background: #111827;\r\n  color: #ffffff;\r\n  border-radius: 6px;\r\n  padding: 6px 8px;\r\n  font-size: 12px;\r\n  line-height: 1.2;\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  opacity: 0;\r\n  pointer-events: none;\r\n  transition: opacity 0.15s ease-in-out;\r\n  z-index: 10000;\r\n}\r\n\r\n.field-info-icon[data-tooltip]:hover::after,\r\n.field-info-icon[data-tooltip]:focus::after {\r\n  opacity: 1;\r\n}\r\n\r\n.field-info-icon:focus {\r\n  outline: 2px solid rgba(35, 109, 180, 0.4);\r\n  outline-offset: 2px;\r\n}\r\n\r\n.dark-mode .field-info-icon {\r\n  background: #0e0e0f;\r\n  color: #e5e7eb;\r\n  border-color: #374151;\r\n}\r\n\r\n.dark-mode .field-info-icon[data-tooltip]::after {\r\n  background: #f9fafb;\r\n  color: #111827;\r\n}\r\n\r\n.high-contrast .field-info-icon[data-tooltip]::after {\r\n  background: #000000;\r\n  color: #ffffff;\r\n}\r\n\r\n.field-info-icon--wrap[data-tooltip]::after {\r\n  white-space: normal;\r\n  width: 220px;\r\n  max-width: 70vw;\r\n  text-align: center;\r\n  line-height: 1.35;\r\n}\r\n\r\n/* Drop the bubble below the icon instead of above it. Use on icons near the\r\n   top of the page, where an upward tooltip gets clipped by the viewport. */\r\n.field-info-icon--bottom[data-tooltip]::after {\r\n  bottom: auto;\r\n  top: calc(100% + 8px);\r\n}\r\n\r\n/* Keep the bubble inside the viewport for icons sitting near the right edge. */\r\n.field-info-icon--align-right[data-tooltip]::after {\r\n  left: auto;\r\n  right: 0;\r\n  transform: none;\r\n}\r\n\r\n/* Circular checkboxes in data tables (Security, Stock, PDF Generator, etc.) */\r\ninput[type=\"checkbox\"].table-checkbox {\r\n  appearance: none;\r\n  -webkit-appearance: none;\r\n  border-radius: 9999px;\r\n  background-color: #ffffff;\r\n  border: 1px solid #d1d5db;\r\n  display: inline-grid;\r\n  place-content: center;\r\n  vertical-align: middle;\r\n}\r\n\r\ninput[type=\"checkbox\"].table-checkbox:checked {\r\n  background-color: #2563eb;\r\n  border-color: #2563eb;\r\n  background-image: url(\"data:image/svg+xml,%3csvg viewBox='0 0 16 16' fill='white' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3e%3c/svg%3e\");\r\n  background-size: 100% 100%;\r\n  background-position: center;\r\n  background-repeat: no-repeat;\r\n}\r\n\r\ninput[type=\"checkbox\"].table-checkbox:focus {\r\n  outline: none;\r\n  box-shadow: 0 0 0 2px #ffffff, 0 0 0 4px #3b82f6;\r\n}\r\n\r\n.dark-mode input[type=\"checkbox\"].table-checkbox {\r\n  background-color: #374151;\r\n  border-color: #4b5563;\r\n}\r\n\r\n.dark-mode input[type=\"checkbox\"].table-checkbox:checked {\r\n  background-color: #3b82f6;\r\n  border-color: #3b82f6;\r\n}\r\n\r\n/* Tracking line start/end point markers on map */\r\n.tracking-point-marker {\r\n  background: transparent !important;\r\n  border: none !important;\r\n}\r\n.tracking-point-marker .tracking-point-label {\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  width: 24px;\r\n  height: 24px;\r\n  border-radius: 50%;\r\n  font-size: 11px;\r\n  font-weight: 700;\r\n  color: #fff;\r\n  border: 2px solid #fff;\r\n  box-shadow: 0 1px 4px rgba(0,0,0,0.35);\r\n}\r\n.tracking-point-marker.tracking-start .tracking-point-label {\r\n  background: #16a34a;\r\n}\r\n.tracking-point-marker.tracking-end .tracking-point-label {\r\n  background: #dc2626;\r\n}\r\n/* Visible scrollbar for react-select dropdown menu (e.g. Next step success/failure) */\r\n.select__menu-list {\r\n  overflow-y: auto !important;\r\n}\r\n\r\n/* Multi-select chips area: flex min-height + visible scrollbar (MultipleActivitySelect) */\r\n.multiple-activity-select-scroll .select__value-container {\r\n  overflow-y: auto !important;\r\n}\r\n\r\n.react-selector-selected-scroll .select__value-container {\r\n  overflow-y: auto !important;\r\n}\r\n\r\n.bottom-toolbar-container {\r\n  display: flex;\r\n  gap: 8px;\r\n  padding: 8px;\r\n  border-radius: 14px;\r\n}\r\n\r\n.bottom-toolbar-btn {\r\n  width: 38px;\r\n  height: 38px;\r\n  border-radius: 10px;\r\n  border: 1px solid #d7dfea;\r\n  background: #e1e7ef;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: all 0.2s ease;\r\n}\r\n.bottom-toolbar-btn:hover{\r\n  border-color: #5286f7;\r\n  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);\r\n}\r\n.bottom-toolbar-btn:hover .active {\r\n color: #5286f7;\r\n  border-color: #5286f7;\r\n  box-shadow: 0 4px 12px -2px rgba(36, 99, 235, 0.18);\r\n}\r\n\r\n.bottom-toolbar-btn svg {\r\n  font-size: 18px;\r\n  color: #374151;\r\n}\r\n\r\n/* Shared list/search contract (PR-1) */\r\n.search-shell {\r\n  display: flex;\r\n  width: 100%;\r\n  height: 42px;\r\n  align-items: stretch;\r\n}\r\n\r\n.search-input {\r\n  width: 100%;\r\n  height: 42px;\r\n  border: 1px solid #d1d5db;\r\n  border-radius: 0;\r\n  padding: 0 12px;\r\n  font-size: 14px;\r\n  line-height: 1.2;\r\n  color: #111827;\r\n  background: #ffffff;\r\n}\r\n\r\n.search-input:focus {\r\n  outline: none;\r\n  border-color: #60a5fa;\r\n  box-shadow: 0 0 0 1px #60a5fa;\r\n}\r\n\r\n.search-input-ltr {\r\n  border-top-left-radius: 10px;\r\n  border-bottom-left-radius: 10px;\r\n  border-right: 0;\r\n  text-align: left;\r\n}\r\n\r\n.search-input-rtl {\r\n  border-top-right-radius: 10px;\r\n  border-bottom-right-radius: 10px;\r\n  border-left: 0;\r\n  text-align: right;\r\n}\r\n\r\n.search-btn {\r\n  width: 48px;\r\n  height: 42px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  background: #236db4;\r\n  color: #ffffff;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.search-btn:hover {\r\n  background: #1d5d9e;\r\n}\r\n\r\n.search-btn-ltr {\r\n  border-top-right-radius: 10px;\r\n  border-bottom-right-radius: 10px;\r\n}\r\n\r\n.search-btn-rtl {\r\n  border-top-left-radius: 10px;\r\n  border-bottom-left-radius: 10px;\r\n}\r\n\r\n.list-meta-row {\r\n  margin-top: 12px;\r\n  display: flex;\r\n  flex-wrap: wrap;\r\n  align-items: center;\r\n  justify-content: space-between;\r\n  gap: 10px;\r\n}\r\n\r\n.list-meta-left {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  color: #9ca3af;\r\n  font-size: 14px;\r\n}\r\n\r\n.list-meta-range {\r\n  white-space: nowrap;\r\n}\r\n\r\n.list-meta-right {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n  color: #9ca3af;\r\n  font-size: 14px;\r\n}\r\n\r\n.pager-nav {\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 6px;\r\n}\r\n\r\n.pager-icon-btn {\r\n  width: 32px;\r\n  height: 32px;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  border-radius: 8px;\r\n  border: 1px solid transparent;\r\n  color: #94a3b8;\r\n  transition: all 0.2s ease;\r\n}\r\n\r\n.pager-icon-btn:hover:not(:disabled) {\r\n  color: #236db4;\r\n  background: #eff6ff;\r\n  border-color: #dbeafe;\r\n}\r\n\r\n.pager-icon-btn:disabled {\r\n  opacity: 0.45;\r\n  cursor: not-allowed;\r\n}\r\n\r\n/* Task Management map/list flip-card selector */\r\n.map-list-flip-toggle {\r\n  position: relative;\r\n  z-index: 1;\r\n  width: 112px;\r\n  height: 40px;\r\n  padding: 0;\r\n  border: 0;\r\n  border-radius: 10px;\r\n  background: transparent;\r\n  perspective: 600px;\r\n  cursor: pointer;\r\n  vertical-align: middle;\r\n}\r\n\r\n.map-list-flip-toggle:hover,\r\n.map-list-flip-toggle:focus-visible {\r\n  z-index: 10001;\r\n}\r\n\r\n.map-list-flip-toggle::after {\r\n  content: attr(data-tooltip);\r\n  position: absolute;\r\n  left: 50%;\r\n  top: calc(100% + 9px);\r\n  z-index: 10002;\r\n  width: 200px;\r\n  max-width: calc(100vw - 24px);\r\n  padding: 8px 12px;\r\n  border: 1px solid #93c5fd;\r\n  border-radius: 7px;\r\n  color: #0369a1;\r\n  background: #eff6ff;\r\n  box-shadow: 0 4px 12px rgba(15, 23, 42, 0.14);\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  line-height: 1.35;\r\n  text-align: center;\r\n  white-space: normal;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  pointer-events: none;\r\n  transform: translate(-50%, 4px);\r\n  transition: opacity 0.18s ease, transform 0.18s ease, visibility 0.18s ease;\r\n}\r\n\r\n.map-list-flip-toggle::before {\r\n  content: \"\";\r\n  position: absolute;\r\n  left: 50%;\r\n  top: calc(100% + 4px);\r\n  z-index: 10003;\r\n  width: 10px;\r\n  height: 10px;\r\n  border-top: 1px solid #93c5fd;\r\n  border-left: 1px solid #93c5fd;\r\n  background: #eff6ff;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  pointer-events: none;\r\n  transform: translateX(-50%) rotate(45deg);\r\n  transition: opacity 0.18s ease, visibility 0.18s ease;\r\n}\r\n\r\n.map-list-flip-toggle:hover::after,\r\n.map-list-flip-toggle:focus-visible::after,\r\n.map-list-flip-toggle:hover::before,\r\n.map-list-flip-toggle:focus-visible::before {\r\n  opacity: 1;\r\n  visibility: visible;\r\n}\r\n\r\n.map-list-flip-toggle:hover::after,\r\n.map-list-flip-toggle:focus-visible::after {\r\n  transform: translate(-50%, 0);\r\n}\r\n\r\n.map-list-flip-toggle--align-left::after {\r\n  left: 0;\r\n  transform: translate(0, 4px);\r\n}\r\n\r\n.map-list-flip-toggle--align-left:hover::after,\r\n.map-list-flip-toggle--align-left:focus-visible::after {\r\n  transform: translate(0, 0);\r\n}\r\n\r\n.map-list-flip-toggle--align-left::before {\r\n  left: 28px;\r\n}\r\n\r\n.map-list-flip-toggle:focus-visible {\r\n  outline: 3px solid rgba(35, 109, 180, 0.3);\r\n  outline-offset: 3px;\r\n}\r\n\r\n.map-list-flip-toggle:disabled {\r\n  cursor: default;\r\n}\r\n\r\n.map-list-flip-toggle__inner {\r\n  position: relative;\r\n  display: block;\r\n  width: 100%;\r\n  height: 100%;\r\n  transform-style: preserve-3d;\r\n  transition: transform 0.52s cubic-bezier(0.4, 0, 0.2, 1);\r\n}\r\n\r\n.map-list-flip-toggle.is-flipping .map-list-flip-toggle__inner {\r\n  transform: rotateY(180deg);\r\n}\r\n\r\n.map-list-flip-toggle__face {\r\n  position: absolute;\r\n  inset: 0;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  gap: 7px;\r\n  border: 1px solid #d7dfea;\r\n  border-radius: 10px;\r\n  backface-visibility: hidden;\r\n  -webkit-backface-visibility: hidden;\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  line-height: 1;\r\n  box-shadow: 0 3px 10px rgba(15, 23, 42, 0.12);\r\n}\r\n\r\n.map-list-flip-toggle__front {\r\n  color: #236db4;\r\n  background: #ffffff;\r\n}\r\n\r\n.map-list-flip-toggle__back {\r\n  color: #ffffff;\r\n  background: #236db4;\r\n  border-color: #236db4;\r\n  transform: rotateY(180deg);\r\n}\r\n\r\n.map-list-flip-toggle:hover .map-list-flip-toggle__front {\r\n  border-color: #93bce1;\r\n  background: #f6faff;\r\n  box-shadow: 0 5px 14px rgba(35, 109, 180, 0.17);\r\n}\r\n\r\nbody.dark .map-list-flip-toggle__front {\r\n  color: #93c5fd;\r\n  background: #1e293b;\r\n  border-color: #475569;\r\n}\r\n\r\nbody.dark .map-list-flip-toggle__back {\r\n  background: #1d4ed8;\r\n  border-color: #60a5fa;\r\n}\r\n\r\nbody.dark .map-list-flip-toggle::after {\r\n  color: #bfdbfe;\r\n  background: #172554;\r\n  border-color: #3b82f6;\r\n}\r\n\r\nbody.dark .map-list-flip-toggle::before {\r\n  background: #172554;\r\n  border-color: #3b82f6;\r\n}\r\n\r\nbody.high-contrast .map-list-flip-toggle__front {\r\n  color: #000000;\r\n  background: #ffffff;\r\n  border: 2px solid #000000;\r\n}\r\n\r\nbody.high-contrast .map-list-flip-toggle__back {\r\n  color: #ffffff;\r\n  background: #000000;\r\n  border: 2px solid #ffffff;\r\n}\r\n\r\n@media (max-width: 639px) {\r\n  .map-list-flip-toggle {\r\n    width: 96px;\r\n    height: 36px;\r\n  }\r\n}\r\n\r\n@media (prefers-reduced-motion: reduce) {\r\n  .map-list-flip-toggle__inner {\r\n    transition-duration: 0.01ms;\r\n  }\r\n}\r\n\r\n/* Custom Marker color picker (react-color-palette) - scoped restyle so it\r\n   sits flush inside our own light popover instead of showing its own dark\r\n   card, and to trim the padding/gap the library ships with by default. */\r\n.custom-marker-color-popover .rcp-root {\r\n  --rcp-background-color: transparent;\r\n  --rcp-field-input-color: #111827;\r\n  --rcp-field-input-border-color: #e5e7eb;\r\n  --rcp-field-label-color: #6b7280;\r\n}\r\n\r\n.custom-marker-color-popover .rcp {\r\n  border-radius: 10px;\r\n  overflow: hidden;\r\n}\r\n\r\n.custom-marker-color-popover .rcp-body {\r\n  padding: 10px 0 0;\r\n  gap: 10px;\r\n}\r\n\r\n.custom-marker-color-popover .rcp-field-input {\r\n  background-color: #f9fafb;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
